module.exports = __webpack_public_path__ + "img/woman-cardiology.84e3f674.png";